<template>
<div v-if="ruleVersion">
  <q-chip v-if="showCheckedOff"
          icon="check_box"
          class="status-chip--small"
          aria-label="Afgerond">
    <q-tooltip class="bg-neutral-80 text-white" anchor="top middle" self="bottom middle"
               :offset="[10, 10]">
      Afgerond
    </q-tooltip>
  </q-chip>

  <q-chip v-if="$ruleIsApproved(activeStatus)"
          icon="done"
          color="positive"
          text-color="white"
          :aria-label="directionalMessages[direction].approved"
          :class="showOtherStatusses ? 'status-chip--small' :'status-chip'">
    <q-tooltip v-if="showOtherStatusses" class="bg-neutral-80 text-white" anchor="top middle" self="bottom middle"
               :offset="[10, 10]">
      {{ directionalMessages[direction].approved }}
    </q-tooltip>
    <span v-else>
     {{ directionalMessages[direction].approved }}
      </span>
  </q-chip>
  <icon-button
      v-else-if="showOtherStatusses"
      icon="done"
      color="positive"
      :aria-label="directionalMessages[direction].approve"
      :disable="approvalDisabled"
      size="sm"
      round
      @click="$emit('approve')"
  />


  <q-chip v-if="$ruleIsRejected(activeStatus)"
          icon="close"
          color="negative"
          text-color="white"
          :aria-label="directionalMessages[direction].rejected"
          :class="showOtherStatusses ? 'status-chip--small' :'status-chip'">
    <q-tooltip v-if="showOtherStatusses" class="bg-neutral-80 text-white" anchor="top middle" self="bottom middle"
               :offset="[10, 10]">
      {{ directionalMessages[direction].rejected }}
    </q-tooltip>
    <span v-else>
        {{ directionalMessages[direction].rejected }}
      </span>
  </q-chip>
  <icon-button
      v-else-if="showOtherStatusses"
      icon="close"
      color="negative"
      :aria-label="rejectionDisabled && !ruleIsAwaitingApproval?
        'Afkeuren is alleen mogelijk als de richtlijn ter toetsing is ingediend' :
        directionalMessages[direction].reject
      "
      :disable="rejectionDisabled"
      size="sm"
      round
      @click="$emit('rejectApproval')"
  />

  <q-chip v-if="showAwaitingApproval"
          color="warning"
          class="status-chip"
          text-color="white"
          outline
          aria-label="Wacht op toetsing">
    <q-tooltip class="bg-neutral-80 text-white" anchor="top middle" self="bottom middle"
               :offset="[10, 10]">
      Wacht op toetsing
    </q-tooltip>
    Wacht op toetsing
  </q-chip>

  <q-chip v-if="showIncomplete"
          class="status-chip"
          :aria-label="Open">
    <q-tooltip class="bg-neutral-80 text-white" anchor="top middle" self="bottom middle"
               :offset="[10, 10]">
      Open
    </q-tooltip>
    Open
  </q-chip>

  <template v-if="showOtherStatusses">
    <template v-if="showRelevancyButtons">
      <icon-button
          v-if="ruleIsIrrelevant"
          icon="add"
          color="warning"
          aria-label="Wel relevant"
          size="sm"
          round
          @click="$emit('makeRelevant')"
      />
      <icon-button
          v-else
          icon="horizontal_rule"
          color="warning"
          aria-label="Niet relevant"
          size="sm"
          round
          @click="$emit('makeIrrelevant')"
      />
    </template>
    <icon-button
        v-if="!$ruleIsIncomplete(activeStatus)"
        icon="undo"
        color="info"
        aria-label="Herstel status"
        size="sm"
        round
        @click="$emit('restoreStatus')"
    />
  </template>
</div>
</template>

<script>
import { ruleMixin } from '~HIOR/mixins'
import { ruleStatus } from '~HIOR/constants'
import { STATUS_APPROVAL_REJECTED } from '../../constants/ruleStatus'

export default {
  mixins: [ruleMixin],
  props: {
    ruleVersion: {
      type: Object,
      required: true,
    },
    direction: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      directionalMessages: {
        approver: {
          approved: 'Afgerond',
          approve: 'Keur goed',
          rejected: 'Afgekeurd',
          reject: 'Keur af',
        },
        'implementer': {
          approved: 'Voldoet',
          approve: 'Voldoet',
          rejected: 'Wijkt af',
          reject: 'Wijk af',
        },
      },
      ruleStatus,
    }
  },
  computed: {
    approvalDisabled () {
      return this.ruleIsIrrelevant
    },
    rejectionDisabled () {
      if (this.ruleIsIrrelevant) {
        return true
      }
      if (this.direction !== 'approver') {
        return false
      }
      return !this.ruleIsAwaitingApproval
    },
    ruleIsIrrelevant () {
      if (!this.ruleVersion) {
        return true
      }
      return this.$ruleIsIrrelevant(this.ruleVersion.pivot.approver_status) ||
          this.$ruleIsIrrelevant(this.ruleVersion.pivot.implementer_status)
    },
    ruleIsAwaitingApproval () {
      if (!this.ruleVersion) {
        return false
      }
      return this.$ruleIsAwaitingApproval(this.ruleVersion.pivot.approver_status)
    },
    showRelevancyButtons () {
      if (!this.$can('markIrrelevantForProject', this.ruleVersion.rule)) {
        return false
      }
      if (this.direction === 'implementer') {
        return true
      }
      return !this.$ruleIsApproved(this.activeStatus)
    },
    showAwaitingApproval () {
      if (!this.ruleVersion || this.showOtherStatusses) {
        return false
      }
      if (this.direction === 'approver') {
        return this.ruleIsAwaitingApproval
      }
      return this.ruleIsAwaitingApproval && (
          this.$ruleIsIncomplete(this.activeStatus) ||
          this.$ruleIsCheckedOff(this.activeStatus)
      )

    },
    showIncomplete () {
      if (!this.ruleVersion || this.direction !== 'approver' || this.showOtherStatusses) {
        return false
      }
      return this.$ruleIsIncomplete(this.activeStatus)
    },
    showCheckedOff () {
      if (!this.ruleVersion || this.direction !== 'implementer' || !this.showOtherStatusses) {
        return false
      }
      return this.$ruleIsCheckedOff(this.activeStatus)
    },
    showOtherStatusses () {
      if (!this.ruleVersion) {
        return false
      }
      if (this.direction === 'approver') {
        return this.$can('approve', this.ruleVersion.rule)

      }
      if (this.direction === 'implementer') {
        return this.$can('approveForProject', this.ruleVersion.rule)
            && !this.$can('approve', this.ruleVersion.rule)
            && !this.$ruleIsApproved(this.ruleVersion.pivot.approver_status)
      }
      return false
    },
    activeStatus () {
      if (!this.ruleVersion) {
        return null
      }
      if (this.direction === 'approver') {
        return parseInt(this.ruleVersion.pivot.approver_status)
      }
      if (this.direction === 'implementer') {
        return parseInt(this.ruleVersion.pivot.implementer_status)
      }
      throw Error('Unknown direction')
    },
  },
}

</script>

<style lang="scss">
.q-chip.status-chip--small {
  display: inline-block;
  padding: 0;
  margin: 0;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  line-height: 35px;
  text-align: center;

  .q-chip__content {
    display: none;
  }

  .q-chip__icon {
    margin: 0;
  }
}

.q-chip.status-chip {
  .q-chip__content {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.q-chip--outline.status-chip.text-warning {
  color: black !important;
  background-color: color-mix(in srgb, var(--q-warning) 15%, transparent) !important;
  border-color: var(--q-warning);
}
</style>
